import { css, StyleSheet } from 'aphrodite';
import { FC } from 'react';
import { Avatar, AvatarProps } from '@HoudiniUI/Avatar';
import { alizarinCrimson } from '../../../../styles/colors';

interface VisibilityIndicatorAvatarProps extends AvatarProps {
	visible: boolean;
	size?: 'large' | 'small';
}

export const VisibilityIndicatorAvatar: FC<VisibilityIndicatorAvatarProps> = ({
	size,
	visible = true,
	imgSrc,
	fallbackText,
	fallbackStyles = [],
	styles = [],
	...rest
}) => {
	return (
		<div className={css(styleSheet.container, styleSheet[size])}>
			<Avatar
				imgSrc={imgSrc}
				fallbackText={fallbackText}
				styles={[styleSheet[size], visible ? null : styleSheet.restricted, ...styles]}
				fallbackStyles={[styleSheet[size], visible ? null : styleSheet.restricted, ...fallbackStyles]}
				{...rest}
			/>
		</div>
	);
};

export const styleSheet = StyleSheet.create({
	container: {
		whiteSpace: 'nowrap',
		position: 'relative',
	},
	restricted: {
		boxShadow: `0 0 0 2px ${alizarinCrimson}`,
	},
	large: {
		height: 50,
		width: 50,
	},
	small: {
		height: 32,
		width: 32,
	},
});
